import * as React from "react";
import { forwardRef } from "react";
const SvgMerge = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-merge-icon lucide-merge", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m8 6 4-4 4 4" }), /* @__PURE__ */ React.createElement("path", { d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22" }), /* @__PURE__ */ React.createElement("path", { d: "m20 22-5-5" }));
const ForwardRef = forwardRef(SvgMerge);
export { ForwardRef as ReactComponent };
